export default __webpack_public_path__ + "static/media/17.6a22c7d9.jpg";